module.exports = __webpack_public_path__ + "img/logo-coucou-hibou.318a7bcb.svg";